import { render, staticRenderFns } from "./AddClientDriver.vue?vue&type=template&id=51a73096&scoped=true"
import script from "./AddClientDriver.vue?vue&type=script&lang=js"
export * from "./AddClientDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a73096",
  null
  
)

export default component.exports